import { useFeatureFlags } from '@olo-web/domain/featureFlags/queries/useFeatureFlags';
import { useMerchantTheme } from '@olo-web/domain/merchants/queries/useMerchantTheme';

export const useAIRecommendationsFlagABStatus = (): {
  showInMenu: boolean;
  showModalBeforeCheckout: boolean;
  showInMenuAndBeforeCheckout: boolean;
  recommendationsEnabled: boolean;
} => {
  const { data: flags } = useFeatureFlags();
  const { data: merchantTheme } = useMerchantTheme();

  const recommendationsEnabled = merchantTheme?.settings?.areRecommendationsEnabled ?? false;

  const showInMenu = flags?.GoogleAISuggestions === 'menu' && recommendationsEnabled;
  const showModalBeforeCheckout =
    flags?.GoogleAISuggestions === 'checkout' && recommendationsEnabled;
  const showInMenuAndBeforeCheckout =
    flags?.GoogleAISuggestions === 'all' && recommendationsEnabled;

  return {
    showInMenu,
    showModalBeforeCheckout,
    showInMenuAndBeforeCheckout,
    recommendationsEnabled,
  };
};
